export default __webpack_public_path__ + "static/media/home-travel-agency-hotel-img03.2930315a.jpg";